module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/3c727352622d5150ca890d790bd74fb2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick_white.svg
// module id = pACL
// module chunks = 0